//import { initAuthCore } from './services/authCore'

import React from 'react'
import { AppProps as SingleSpaAppProps } from 'single-spa'

export type AppProps = SingleSpaAppProps & {
    homeProps?: {
        basename: string
    }
}

const App = () => {
    return (
        <React.Suspense fallback={<h6>Loading...</h6>}>
            <></>
        </React.Suspense>
    )
}

export default App
